import React, { forwardRef }  from 'react';

const CheckBox = forwardRef((props, ref) => {
    let checkbox_default_value = false;
    let url = props.data['name'].toLowerCase()?.split(" ").join("_");
    if(url[url.length-1] === '_') {
        url = url.slice(0, -1);
    }
    if (props.URL_PARAMS.get(url)) {
        checkbox_default_value = true;
    }
    return (
        <div className="input-section" key={props.index}>
            <div className="checkbox-nav">
                {/* <input required={props.data['required']} ref={ref} id={`checkbox${props.index}`} className="input-checkbox" type="checkbox" defaultChecked={checkbox_default_value || false} />
                <label htmlFor={`checkbox${props.index}`}>
                    {props.data['name']}

                    { props.data['required'] && (
                        <span className="required" style={{ color: props.color }}>*</span>
                    )}
                </label> */}

                <label className="checkbox">
                    <span className="checkbox__input">
                        <input
                            type="checkbox"
                            name="checkbox"
                            ref={ref}
                            required={props.data['required']}
                            defaultChecked={checkbox_default_value} />
                        <span
                            className="checkbox__control"  >
                            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden="true" focusable="false" fill={props.color}>
                                <path
                                    fill='none'
                                    stroke={`${props.color}`}
                                    strokeWidth='3'
                                    d='M1.73 12.91l6.37 6.37L22.79 4.59' />
                            </svg>
                        </span>
                    </span>
                    <label className="radio__label" htmlFor={`checkbox${props.index}`}>
                        {props.data['name']}

                        { props.data['required'] && (
                            <span className="required" style={{ color: props.color }}> *</span>
                        )}
                    </label>
                </label>
            </div>
        </div>
    )
});

export default CheckBox;
